module.exports = __webpack_public_path__ + "img/lawjudge3.0ef5b416.png";